import React from 'react';

import { Stack } from '@mui/material';

import { NetworkRequestOutcome } from '@/parsing/parsers/common/NetworkRequestOutcome';

type Props = {
  outcome: NetworkRequestOutcome;
};

type StringifiedOutcome = {
  outcomePrefix: string;
  outcomeString: string;
  responseCssClassName: string;
};

export class NetworkRequestColorCodingTooltipContent extends React.Component<Props> {
  render() {
    const str = this.stringifyOutcome(this.props.outcome);

    return (
      <Stack direction="column" spacing="8px">
        <Stack direction="row" alignItems="center">
          <span>{str.outcomePrefix}</span>
          &nbsp;
          <span className={str.responseCssClassName} style={{ color: 'black' }}>
            <b>{str.outcomeString}</b>
          </span>
        </Stack>

        <div>
          <div>Possible statuses are:</div>

          <Stack direction="row" alignItems="center" spacing="4px">
            {this.possibleStatusForOutcome(NetworkRequestOutcome.Succeeded)}
            {this.possibleStatusForOutcome(NetworkRequestOutcome.Failed)}
            {this.possibleStatusForOutcome(NetworkRequestOutcome.ProbablyFailed)}
            {this.possibleStatusForOutcome(NetworkRequestOutcome.Canceled)}
            {this.possibleStatusForOutcome(NetworkRequestOutcome.Unknown)}
          </Stack>
        </div>

        <div>
          <span>
            Request is marked as&nbsp;
            {this.possibleStatusForOutcome(NetworkRequestOutcome.ProbablyFailed)}
          </span>

          <ul>
            <li>
              if request was initially considered&nbsp;
              {this.possibleStatusForOutcome(NetworkRequestOutcome.Succeeded)}
            </li>
            <li>
              but &quot;code&quot; in response JSON is not 0, which <i>probably</i> means that
              response is failed.
            </li>
          </ul>
        </div>
      </Stack>
    );
  }

  private possibleStatusForOutcome(outcome: NetworkRequestOutcome) {
    const str = this.stringifyOutcome(outcome);
    return (
      <span className={str.responseCssClassName} style={{ color: 'black' }}>
        {str.outcomeString}
      </span>
    );
  }

  private stringifyOutcome(outcome: NetworkRequestOutcome): StringifiedOutcome {
    let result: StringifiedOutcome;

    switch (outcome) {
      case NetworkRequestOutcome.Unknown:
        result = {
          outcomePrefix: 'This request is',
          outcomeString: 'unknown',
          responseCssClassName: 'network-response-unknown',
        };
        break;
      case NetworkRequestOutcome.Canceled:
        result = {
          outcomePrefix: 'This request was',
          outcomeString: 'canceled',
          responseCssClassName: 'network-response-canceled',
        };
        break;
      case NetworkRequestOutcome.Succeeded:
        result = {
          outcomePrefix: 'This request has',
          outcomeString: 'succeeded',
          responseCssClassName: 'network-response-succeeded',
        };
        break;
      case NetworkRequestOutcome.Failed:
        result = {
          outcomePrefix: 'This request has',
          outcomeString: 'failed',
          responseCssClassName: 'network-response-failed',
        };
        break;
      case NetworkRequestOutcome.ProbablyFailed:
        result = {
          outcomePrefix: 'This request has',
          outcomeString: 'failed (maybe)',
          responseCssClassName: 'network-response-probably-failed',
        };
        break;
    }

    return result;
  }
}
